import { render, staticRenderFns } from "./user_confirmed_successfully.vue?vue&type=template&id=0b8f600c&scoped=true"
import script from "./user_confirmed_successfully.vue?vue&type=script&lang=js"
export * from "./user_confirmed_successfully.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8f600c",
  null
  
)

export default component.exports